import React, { useMemo, useRef } from "react";
import MiniRuleTree from "./RuleTree/RuleChat/MiniRuleTree";
import RuleArtifactCard from "./RuleTree/RuleChat/RuleArtifactCard";
import "./RuleTree/ruleAgentTheme.css";

export const RULE_ARTIFACT_IDENTIFIER = "qi-rule-artifact";
export const RULE_SELECTION_IDENTIFIER = "qi-rule-selection";

export const SELECTION_PROMPT = "O que estes trechos fazem nesta regra?";

function RuleArtifactBlock({ content, host }) {
    let artifact = JSON.parse(content);
    if (!artifact || typeof artifact !== "object" || !artifact.rule) {
        throw new Error("qi-rule-artifact carries no rule object");
    }

    // The SDK memoizes rendered messages, so this block may not re-render when
    // the tree changes. Resolve the insert callback at click time: a callback
    // captured at render time closes over a stale tree, and inserting with it
    // overwrites every edit made since the card appeared.
    const insertNodes = (nodes) => {
        let { onInsertNodes } = host.current;
        if (typeof onInsertNodes === "function") onInsertNodes(nodes);
    };

    let { rulesContext, userVariablesAvailable } = host.current;
    return (
        <RuleArtifactCard
            artifact={artifact}
            rulesContext={rulesContext}
            userVariablesAvailable={userVariablesAvailable}
            onInsertNodes={insertNodes}
        />
    );
}

function RuleSelectionBlock({ content }) {
    let selection = JSON.parse(content);
    if (!selection || !Array.isArray(selection.tree_data)) {
        throw new Error("qi-rule-selection carries no tree_data");
    }

    return <MiniRuleTree treeData={selection.tree_data} />;
}

export function useRuleArtifactRenderers({ rulesContext, userVariablesAvailable, onInsertNodes }) {
    const host = useRef({});
    host.current = { rulesContext, userVariablesAvailable, onInsertNodes };

    return useMemo(
        () => [
            {
                identifier: RULE_ARTIFACT_IDENTIFIER,
                renderer: ({ content }) => <RuleArtifactBlock content={content} host={host} />
            },
            {
                identifier: RULE_SELECTION_IDENTIFIER,
                renderer: ({ content }) => <RuleSelectionBlock content={content} />
            }
        ],
        []
    );
}

export function toSelectionAttachment({ rootId, label, treeData }) {
    return {
        id: rootId,
        identifier: RULE_SELECTION_IDENTIFIER,
        content: JSON.stringify({ label: label, tree_data: treeData }),
        label: label,
        defaultPrompt: SELECTION_PROMPT
    };
}
